export default class ConsultSummaryByAreaCtrl{

  constructor ($scope, $rootScope, WorkPlanSrv, $mdDialog, $cookieStore,$state, $cookies, GlobalConfig, $sessionStorage){
    var summaryByAreaVm = this
    $rootScope.fullscreenClass = 'background-planning'
    summaryByAreaVm.showModalMessages = showModalMessages
    summaryByAreaVm.messagesList = []
    summaryByAreaVm.userId = 0
    summaryByAreaVm.classDiagram = "";
    summaryByAreaVm.teacherId = 0
    summaryByAreaVm.radioGreen = "#04B404"
    summaryByAreaVm.submoduleroute = submoduleroute
    summaryByAreaVm.getValidateModule = getValidateModule
    summaryByAreaVm.disableButton = true
    summaryByAreaVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    summaryByAreaVm.$sessionStorage = $sessionStorage

    var submoduleArray = $cookieStore.get('subModuleId')
    const currentUser = JSON.parse($cookies.get('currentUser'))

    summaryByAreaVm.assignStyles = () => {
      switch(parseInt(summaryByAreaVm.timeline)) {

        case 1:
          summaryByAreaVm.classCircleGreen1 = 'green'
          break
        case 2:
            summaryByAreaVm.classCircleGreen1 = 'green'
            summaryByAreaVm.classBarGreen1 = 'green'
          break
        case 3:
          summaryByAreaVm.classCircleGreen1 = 'green'
          summaryByAreaVm.classCircleGreen2 = 'green'
          summaryByAreaVm.classBarGreen1 = 'green'
          break
        case 4:
          summaryByAreaVm.classCircleGreen1 = 'green'
          summaryByAreaVm.classCircleGreen2 = 'green'
          summaryByAreaVm.classCircleGreen3 = 'green'
          summaryByAreaVm.classBarGreen1 = 'green'
          summaryByAreaVm.classBarGreen2 = 'green'
          break
        case 5:
            summaryByAreaVm.classCircleGreen1 = 'green'
            summaryByAreaVm.classCircleGreen2 = 'green'
            summaryByAreaVm.classCircleGreen3 = 'green'
            summaryByAreaVm.classBarGreen1 = 'green'
            summaryByAreaVm.classBarGreen2 = 'green'
            summaryByAreaVm.classBarGreen3 =' green'
          break
        case 6:
          summaryByAreaVm.classCircleGreen1 = 'green'
          summaryByAreaVm.classCircleGreen2 = 'green'
          summaryByAreaVm.classCircleGreen3 = 'green'
          summaryByAreaVm.classCircleGreen4 = 'green'
          summaryByAreaVm.classBarGreen1 = 'green'
          summaryByAreaVm.classBarGreen2 = 'green'
          summaryByAreaVm.classBarGreen3 = 'green'
          break
        case 7:
            summaryByAreaVm.classCircleGreen1 = 'green'
            summaryByAreaVm.classCircleGreen2 = 'green'
            summaryByAreaVm.classCircleGreen3 = 'green'
            summaryByAreaVm.classCircleGreen4 = 'green'
            summaryByAreaVm.classBarGreen1 = 'green'
            summaryByAreaVm.classBarGreen2 = 'green'
            summaryByAreaVm.classBarGreen3 = 'green'
          break
        default:
      }
    }

    activate()  

    function activate() {      
      if($cookieStore.get("isReproved")){
        showModalReactivateWorkplan()
      }else{
        getData()
      }
    }

    function getValidateModule(submodule){
      let result = false
      for(var i = 0, len = submoduleArray.length; i < len; i++) {
        if (submoduleArray[i].submoduleId == submodule) {
          result = true
          break
        }
      }

      if(!result)
        return ' disabled'
      else
        return ''
    }

    function getData(){
      summaryByAreaVm.userId = $cookieStore.get("currentUser").id
      summaryByAreaVm.teacherId = currentUser.teacherId
      getElements()
      getMessages()
    }

    function submoduleroute (submodule) {
      for (var i = 0, len = submoduleArray.length; i < len; i++) {
        if (submoduleArray[i].submoduleId == submodule) {
          if (submodule == GlobalConfig.modules.teaching) {
            $state.go('workplan.teachingSubjects')
          }

          if (submodule == GlobalConfig.modules.academicManagement) {
            $state.go('workplan.academicManagement')
          }

          if (submodule == GlobalConfig.modules.consolidation) {
            $state.go('workplan.teachingDevelopment')
          }

          if (submodule == GlobalConfig.modules.extentionAndVisibility) {
            $state.go('workplan.extensionAndVisibility')
          }

          if (submodule == GlobalConfig.modules.investigation) {
            $state.go('workplan.investigation')
          }
        }
      }
    }

    // Submodule order the SQL/UI expects (matches ORDER BY FIELD(s.submoduleId,2,6,4,3,5)).
    // Used to synthesize empty 0% anillos when the teacher has no activities yet — see USUITE-14167.
    const WORKPLAN_SUBMODULES = [
      { submoduleId: 2, submoduleName: 'Docencia' },
      { submoduleId: 6, submoduleName: 'Investigación' },
      { submoduleId: 4, submoduleName: 'Extensión y visibilidad' },
      { submoduleId: 3, submoduleName: 'Gestión académica' },
      { submoduleId: 5, submoduleName: 'Consolidación del cuerpo profesoral' },
    ]

    function buildEmptyAnillos() {
      return WORKPLAN_SUBMODULES
        .filter((sm) => submoduleArray && submoduleArray.some((s) => s.submoduleId === sm.submoduleId))
        .map((sm) => {
          const fromCookie = submoduleArray.find((s) => s.submoduleId === sm.submoduleId)
          return {
            submoduleId: sm.submoduleId,
            submoduleName: (fromCookie && fromCookie.submoduleName) || sm.submoduleName,
            percentage: 0,
            hours: 0,
          }
        })
    }

    function getElements(){
        WorkPlanSrv.getElementsRightBar.getList({teacherId:summaryByAreaVm.teacherId}).$promise.then((dataReturn) => {
          if(dataReturn.status == true){
            delete $sessionStorage.workPlanGeneralList
            summaryByAreaVm.$sessionStorage.workPlanGeneralList = dataReturn.data
            var index = 0
            summaryByAreaVm.RightBar = dataReturn.data
            // Teachers with zero activities get an empty asignaturesPlaned[] from the
            // backend (the SQL's UNION ALL fallback is filtered out by the inner join
            // on wpt_code). Synthesize one row per accessible submodule so the anillos
            // render at 0% instead of disappearing.
            if (!summaryByAreaVm.RightBar.asignaturesPlaned || summaryByAreaVm.RightBar.asignaturesPlaned.length === 0) {
              summaryByAreaVm.RightBar.asignaturesPlaned = buildEmptyAnillos()
            }
            summaryByAreaVm.asignaturesPlaned = summaryByAreaVm.RightBar.asignaturesPlaned.map(summaryByAreaVm=>{
              summaryByAreaVm.classDiagram = 'principal-diagram c100 big center ' + 'p' + summaryByAreaVm.percentage + getValidateModule(summaryByAreaVm.submoduleId)
              return summaryByAreaVm
            })
            //console.log(dataReturn.data)
            if (summaryByAreaVm.RightBar.asignaturesPlaned[index]) {
              summaryByAreaVm.teachingSubjects = summaryByAreaVm.RightBar.asignaturesPlaned[index].percentage
            }
            if (summaryByAreaVm.RightBar.asignaturesPlaned[2]) {
              summaryByAreaVm.doctoralFormation = summaryByAreaVm.RightBar.asignaturesPlaned[2].percentage
            }
            if (summaryByAreaVm.RightBar.asignaturesPlaned[1]) {
              summaryByAreaVm.delegationCharges = summaryByAreaVm.RightBar.asignaturesPlaned[1].percentage
            }
            if (summaryByAreaVm.RightBar.timeline && summaryByAreaVm.RightBar.timeline[index]) {
              summaryByAreaVm.timeline = summaryByAreaVm.RightBar.timeline[index].stageId
              summaryByAreaVm.stage = summaryByAreaVm.RightBar.timeline[index].stage
            }
            summaryByAreaVm.assignStyles()
          }else{
            console.log("Comunications problem with the server")
          }
        },(data) => {
             console.log(data)
        })
    }

    function getMessages () {
      //WorkPlanSrv.getMessages.get({userId:summaryByAreaVm.userId}).$promise.then(function (dataReturn) {
      WorkPlanSrv.getMessagesNotification.get({userId:summaryByAreaVm.userId}).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          summaryByAreaVm.messagesList = dataReturn.data
        } else {
          summaryByAreaVm.messagesList = []
        }
        summaryByAreaVm.disableButton = false
      })
    }

    function showModalMessages(){
    	let userId       = summaryByAreaVm.userId
    	let messagesList = summaryByAreaVm.messagesList
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function showModalMessages($scope, $mdDialog) {
        	var modalMessagesVm = this

        	//declaracion de variables
          modalMessagesVm.userId       = userId
          modalMessagesVm.messagesList = messagesList
			    modalMessagesVm.class1       = "mdi-hardware-keyboard-arrow-down"
			    modalMessagesVm.class2       = "mdi-hardware-keyboard-arrow-up"
			    modalMessagesVm.classRead    = "mdi-content-drafts"
			    modalMessagesVm.classUnRead  = "mdi-content-mail"

			    //declaracion de funciones
			    modalMessagesVm.showMessage = showMessage
			    modalMessagesVm.close       = close

			    activate()
			    function activate(){
			    	//updateReadMessage()
			    }

			    function showMessage(pos) {
			      if (modalMessagesVm.messagesList[pos].isHiden) {
			        modalMessagesVm.messagesList[pos].isHiden = false
			      } else {
			        modalMessagesVm.messagesList[pos].isHiden = true
			      }
			      //si el mensaje esta leido se muestra un ojo justo al lado de la flecha que muestra el mensaje.
			     	//en caso contrario no muestra nada
			      if (modalMessagesVm.messagesList[pos].isRead == 0) {
              //updateReadMessage(pos)
              modalMessagesVm.messagesList[pos].isRead = 1
			      }
			    }

			    function updateReadMessage (pos) {
			      WorkPlanSrv.updateReadingMessages.update({
			      	userId:modalMessagesVm.userId
			      }).$promise.then(function (dataReturn) {
			        if (dataReturn.status) {
			          modalMessagesVm.messagesList[pos].isRead = 1
			        } else {
			          console.log('error de comunicacion con el servidor')
			        }
			      }, function (data) {
			        console.log(data)
			      })
			    }

          function close() {
          	$mdDialog.hide();
          }

        }],
        template: require('./messagesModal.html'),
        controllerAs: 'modalMessagesVm',
        clickOutsideToClose:false
      });
    }

    function showModalReactivateWorkplan() {
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function($scope, $mdDialog) {
          $scope.reactivate = function(isNew) {
            showModalConfirm(isNew)
            //$mdDialog.hide()
          }
          $scope.close = function() {
            $mdDialog.hide()
            $state.go('fullscreen.welcomeHome')
          }
        }],
        template: require('./reactivateWorkplanModal.html'),
        clickOutsideToClose:false
      })
    }

    function showModalConfirm(isNew) {
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function showModalConfirm($scope, $mdDialog) {
          $scope.continue = function() {

            let post = {
              teacherId: $cookieStore.get("currentUser").teacherId,
              workplanId: $cookieStore.get("currentUser").workplanId,
              isNew: isNew
            }
            return WorkPlanSrv.setPlanningWorkplanByTeacher.set(post).$promise.then(function (dataReturn) {
              if (dataReturn.status) {
                $cookieStore.put('isReproved', 0)
                $mdDialog.hide()
                $state.reload()
                getData()
              }
            }, function (data) {
              console.log(data)
              $mdDialog.hide()
            })
          }
          $scope.close = function() {
            $mdDialog.hide()
            //getData()
            $state.go('fullscreen.welcomeHome')
          }
        }],
        template: require('./confirmReactivateWorkplanModal.html'),
        clickOutsideToClose:false
      })
    }

  }
}

ConsultSummaryByAreaCtrl.$inject = ['$scope','$rootScope','WorkPlanSrv','$mdDialog', '$cookieStore','$state', '$cookies', 'GlobalConfig', '$sessionStorage'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/generalInformation/consultInformation/consultSummaryByAreaCtrl.js